var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEstado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48438 28.0782L22.0546 21.7313V17.019C26.6429 16.2876 30.8173 13.9363 33.8209 10.3914L48.3911 22.3176V10.8214C48.3864 9.93125 48.03 9.07908 47.3996 8.45066C46.7692 7.82224 45.9159 7.46854 45.0258 7.46667H10.8391C9.95079 7.47134 9.10022 7.82628 8.4721 8.4544C7.84398 9.08252 7.48904 9.93309 7.48438 10.8214V28.0782Z",
    fill: "#DB0B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0441 30.7115V26.2943L7.4668 32.627V37.1899L22.0441 30.7115Z",
    fill: "#EF801C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0441 35.2744L7.4668 41.6072H22.0441V35.2744Z",
    fill: "#EF801C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0439 26.2943L26.7526 24.2331V19.6701L22.0439 21.7313V26.2943Z",
    fill: "#EF801C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0439 30.7115V35.2744L26.7526 33.2133V28.6503L22.0439 30.7115Z",
    fill: "#EF801C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9705 41.6071H48.5443V22.4669L33.8213 10.3914L33.9705 41.6071Z",
    fill: "#EF801C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8213 41.6071H33.9705L33.8213 10.3914V41.6071Z",
    fill: "#EF801C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9666 41.6071H7.48438V45.1609C7.48438 46.0553 7.83969 46.9131 8.47215 47.5455C9.10461 48.178 9.96241 48.5333 10.8568 48.5333H45.1892C46.0837 48.5333 46.9415 48.178 47.5739 47.5455C48.2064 46.9131 48.5617 46.0553 48.5617 45.1609V41.6071H33.9666Z",
    fill: "#0058A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEstado);
export default __webpack_public_path__ + "static/media/LogoEstado.125345b28af44b08598c9074907fbd94.svg";
export { ForwardRef as ReactComponent };